import { syncPathOnGroup, computePathBBox, isPathObject, type PathPoint } from "../../pathGeometry";
import type { SceneObject } from "../../SceneHost";
import {
  pathLinecap,
  pathLinejoin,
  pathStrokeColor,
  pathStrokeDash,
  pathStrokeWidth,
  readObjectStyle,
} from "../../../lib/board/sceneStyle";

const SVG_NS = "http://www.w3.org/2000/svg";

function pathPointsFingerprint(pts: PathPoint[]): string {
  let h = pts.length;
  for (let i = 0; i < pts.length; i++) {
    const p = pts[i]!;
    h = (h * 31 + Math.round(p[0] * 100)) | 0;
    h = (h * 31 + Math.round(p[1] * 100)) | 0;
  }
  return String(h);
}

function pathRenderKey(obj: SceneObject): string {
  if (!isPathObject(obj)) return "";
  const pts = obj.points;
  const style = readObjectStyle(obj);
  return [
    pathPointsFingerprint(pts),
    pathStrokeWidth(obj),
    pathStrokeColor(obj),
    pathLinecap(obj),
    pathLinejoin(obj),
    pathStrokeDash(obj),
    style.strokeOpacity ?? "",
  ].join("|");
}

export function pathDomMatchesObject(g: SVGGElement, obj: SceneObject): boolean {
  if (!isPathObject(obj)) return false;
  return g.getAttribute("data-path-key") === pathRenderKey(obj);
}

/** Обновляет SVG path только если геометрия/стиль изменились. */
export function syncPathObjectOnGroup(g: SVGGElement, obj: SceneObject): boolean {
  if (!isPathObject(obj)) return false;
  const key = pathRenderKey(obj);
  if (g.getAttribute("data-path-key") !== key) {
    syncPathOnGroup(g, obj);
    g.setAttribute("data-path-key", key);
  }
  return true;
}

export function renderPathObject(obj: SceneObject): SVGGElement | null {
  if (!isPathObject(obj)) return null;

  const strokeWidth = pathStrokeWidth(obj);
  const bbox = computePathBBox(obj.points, strokeWidth);
  obj.x = bbox.x;
  obj.y = bbox.y;
  obj.w = bbox.w;
  obj.h = bbox.h;

  const g = document.createElementNS(SVG_NS, "g");
  g.setAttribute("class", "wb-scene-obj wb-scene-obj--path");
  g.setAttribute("data-object-id", obj.id);
  g.setAttribute("transform", `translate(${obj.x},${obj.y})`);

  const pathEl = document.createElementNS(SVG_NS, "path");
  pathEl.setAttribute("fill", "none");
  pathEl.setAttribute("pointer-events", "visibleStroke");
  g.appendChild(pathEl);

  syncPathObjectOnGroup(g, obj);
  return g;
}

export { syncPathOnGroup } from "../../pathGeometry";
